import { render } from "./TheLoaiTuyenDuongQuetRac.vue?vue&type=template&id=18f2bc00"
import script from "./TheLoaiTuyenDuongQuetRac.vue?vue&type=script&lang=js"
export * from "./TheLoaiTuyenDuongQuetRac.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__